var React = require('react');

function FilledArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.27701 0.747765L0.450621 4.99931C0.276869 5.19237 0.413878 5.5 0.673609 5.5H8.32639C8.58612 5.5 8.72313 5.19237 8.54938 4.99931L4.72299 0.747765C4.60382 0.615351 4.39618 0.615351 4.27701 0.747765Z","fill":"#36B37E"}));
}

FilledArrow.defaultProps = {"width":"9","height":"6","viewBox":"0 0 9 6","fill":"none"};

module.exports = FilledArrow;

FilledArrow.default = FilledArrow;
